
import { defineComponent, SetupContext, computed, ref, PropType } from "vue";
import NativeClient from "@/client/native-client";
import { RecipeFoodItem, FoodItem, RecipeFoodItemInfo } from "@/types/pantry";
import PantryFoodItem from "./PantryFoodItem.vue";
export default defineComponent({
  name: "PantryRecipeSearchView",
  components: {
    PantryFoodItem
  },
  props: {
    list: {
      type: Array as PropType<RecipeFoodItem[]>,
      default: () => []
    },
    keyword: {
      type: String,
      default: ""
    }
  },
  setup(props, context: SetupContext) {
    const keyword = ref(props.keyword);
    const textInput = ref<HTMLInputElement>();
    const isShowInputItem = ref(false);
    const getInputItem = (word: string) => {
      let result = "";
      if (word != "") {
        result += "「" + word + "」" + "でレシピを検索";
      }
      return result;
    }
    const inputItem = ref(getInputItem(keyword.value));
    const keywordComputed = computed({
      get: () => keyword.value,
      set: value => (keyword.value = value)
    });
    const clickBack = () => {
      keyword.value = "";
      context.emit("click-close");
    };
    const clickSearch = () => {
      if (keyword.value == null || keyword.value == "") {
        return;
      }
      inputItem.value = getInputItem(keyword.value);
      isShowInputItem.value = true;
      context.emit("click-search", keyword.value);
    };
    const getList = () => {
      if (props.list == null) {
        return null;
      }
      const list = Array<FoodItem>();
      let i = 0;
      for (const item of props.list) {
        const info = new FoodItem(item.name, item.icon, item.foodId, new RecipeFoodItemInfo(item));
        list.push(info);
        i++;
      }
      NativeClient.sendDebugLog("PantryRecipeSearchView getList result=" + JSON.stringify(list));
      return list;
    };
    const clickFood = () => {
      if (keyword.value == "") {
        return;
      }
      const item = new FoodItem(keyword.value, null, -1, null);
      keyword.value = "";
      context.emit("select-food", item);
    };
    const selectFood = (item: FoodItem) => {
      keyword.value = "";
      context.emit("select-food", item);
    };
    const handleEnter = () => {
      if (textInput.value != undefined) {
        textInput.value.blur();
      }
    };
    return {
      clickBack,
      clickSearch,
      keywordComputed,
      getList,
      clickFood,
      selectFood,
      inputItem,
      textInput,
      handleEnter,
      isShowInputItem
    };
  }
});
